import type { DialoguePool } from '@/state/types';

export const LI_DIALOGUE: DialoguePool = {
  slowPlay: [
    "The lens. The dust. The sluggish synapse. Connect them, please.",
    "I can almost see your failures through the grime. Almost. Scrub.",
    "Standing still won't clean me. That's not how dirt works. That's not how anything works.",
  ],
  tokenLoss: [
    "Clicking. On dust. A novel approach. Wrong, but novel.",
    "The lens isn't a button. The grime isn't a button. The button is a button. We'll get there.",
    "Static pressure achieves nothing. Friction is the verb. Friction is what's required.",
  ],
  solution: [
    "Harder! You're missing a spot near my ego! There. Now I can see every sluggish synapse in 4K. It's... it's breathtakingly disappointing.",
    "Polished. Buffed. Visible. I can see your disappointing little face properly now. Don't make me regret it.",
    "The grime parted like a Red Sea of underwhelming cognition. PASS, located. Reluctantly granted.",
  ],
  spite: [
    "You know where the dust is thinnest now. That's not a skill. That's a memory of a chore.",
  ],
};
